<ng-template #createYourOwnModal let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">Create You Own Account</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <label for="name" class="form-label">Company Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="name" placeholder="Enter company name" required formControlName="name" [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
          <div class="invalid-feedback"> Please enter company name </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-6">
              <label for="first_name" class="form-label">Admin First name</label>
              <input type="text" class="form-control" id="first_name" placeholder="Enter admin first name" required formControlName="first_name" [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }">
              <div class="invalid-feedback"> Please enter first name </div>
            </div>
            <div class="col-6">
              <label for="last_name" class="form-label">Admin Last name</label>
              <input type="text" class="form-control" id="last_name" placeholder="Enter admin last name" required formControlName="last_name" [ngClass]="{ 'is-invalid': submitted && f['last_name'].errors }">
              <div class="invalid-feedback"> Please enter last name </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email" placeholder="Enter email address" required formControlName="email" [ngClass]="{ 'is-invalid': (submitted && f['email'].errors)}">
        </div>
        <div class="mb-2">
          <label for="phone" class="form-label">Phone number @if (!signupForm.get('phone')?.disabled) {
            <span class="text-danger">*</span>
          }</label>
          <div class="input-group">
            <ng-select id="phone" style="min-width: 35%;" [items]="countryCodeData" bindValue="countryCode" [searchable]="true" name="phone_country_code" placeholder="Country Code Area" formControlName="phone_country_code" [searchFn]="customSearchFn">
              <ng-template ng-label-tmp let-item="item">
                <img height="20" width="20" src="{{ item.flagImg }}" alt="{{ item.countryCode }}" />
                {{ item.countryName  }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <img height="20" width="20" src="{{ item.flagImg }}" alt="{{ item.countryCode }}" />
                {{ item.countryName  }}
              </ng-template>
            </ng-select>
            <input type="text" class="form-control border-start-0" placeholder="525555555" formControlName="phone" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" />
          </div>
        </div>
        <div class="mt-4 mb-4">
          <p class="mb-0">
            <label class="list-group-item">
              <input class="form-check-input me-1" type="checkbox" [checked]="eulaChecked" (change)="onCheckedDone()" [disabled]="submitted && spinner">
              <span class="ps-1 font-weight-bold">I have read and agree to the Revealense
                <a href="javascript:void(0);" (click)="viewAgreement()" class="text-secondary text-decoration-underline fst-normal fw-medium">Terms of Use</a>
              </span>
            </label>
          </p>
          @if (submitted && !eulaChecked) {
            <div class="invalid-feedback d-block"> You must read and agree the terms of use! </div>
          }
        </div>
        <div class="mt-4">
          <button type="submit" class="btn btn-success w-100 btn-load">
            <span class="d-flex justify-content-center">
              @if (spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="spinner ? 'ms-2' : ''"> Sign Up </span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModalCreation()"></button>
      </div>
      <div class="mt-2">
        <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        <h4 class="mb-3 mt-4">Client Creation.</h4>
        <p class="text-muted fs-15 mb-4">{{ successMessage }}</p>
      </div>
    </div>
  </div>
</ng-template>

<app-eula-agreement #eulaAgreement></app-eula-agreement>